import React from 'react';
import './FullPageFolder.scss';
import Loader from "./Loader";

const FullPageFolder = () => {
  return (
    <div className='FullPageFolder'>
      <Loader />
    </div>
  )
};

export default FullPageFolder;
